<template>
  <a-modal
    class="contact-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #parent_id>
        <a-tree-select
          v-decorator="['parent_id',{rules: [
            { required: true},
          ],}]"
          :tree-data="parentData"
          :disabled="disabled"
        />
      </template>
      <template #name>
        <a-input
          v-decorator="['name',{rules: [
            { required: true, message: '请输入栏目名称' },
          ],}]"
          placeholder="请输入栏目名称"
        />
      </template>
      <template #department_id>
        <a-tree-select
          v-decorator="['department_id',{rules: [
            { required: true, message: '请输入选择科室' },
          ],}]"
          :tree-data="departmentData"
          placeholder="选择科室"
        />
      </template>
      <template #cover>
        <a-upload
          v-decorator="[
            'cover',
            {
              initialValue: [],
              rules: [{ required: true, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg,.png,.jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('cover').length === 1 && $refs.basicForm.form.getFieldValue('cover')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('cover')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
      <template #post_content>
        <a-textarea
          v-decorator="[
            'post_content',
            { rules: [{ required: true, message: '请输入' }] },
          ]"
          rows="3"
          placeholder="请输入"
          maxlength="150"
        />
      </template>
      <template #list_order>
        <a-input-number
          v-decorator="['list_order',{rules: [
            { required: true, message: '请输入排序' },
          ],}]"
          placeholder="请输入排序"
          style="width:100%"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import {
  formData,
} from '../data/index';
export default{
  props: ['title', 'visible', 'btnIsLoading', 'disabled'],
  data(){
    return{
      formData,
      loading: false,
      parentData: [{value: '0', key: 0, title: '无'}],
      departmentData: [],
    };
  },
  mounted(){
    this.getParentData();
    this.getDepartmentData();
  },
  methods: {
    // 递归处理
    dealData(data) {
      data.forEach((item) => {
        item.title=item.name;
        item.key=item.id;
        item.value=String(item.id);
        item.children=item.child_list;
        if (item.child_list && item.child_list.length > 0) {
          this.dealData(item.child_list);
        }
      });
      return data;
    },
    // 获取上级数据
    async getParentData() {
      let result = await this.$http.post('/groups/adminGetList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.parentData = [...this.parentData, ...this.dealData(JSON.parse(JSON.stringify(data)))];
        console.log('getParentData -> this.parentData', this.parentData);
      }
    },
    // 获取科室
    async getDepartmentData() {
      let result = await this.$http.post('/department/adminGetList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item)=>{return {selectable: false, ...item};});
        console.log('getDepartmentData -> data', data);
        this.departmentData = this.dealData(JSON.parse(JSON.stringify(data)));
      }
    },
    normFile(e) {
      if (e && e.file.status === 'uploading') {
        this.loading = true;
      }
      if(e && e.file.status === 'done'){
        const fileList = [{
          uid: e.file.response.data.id,
          status: 'done',
          name: 'img',
          url: e.file.response.data.url,
        }];
        this.loading = false;
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('图片小于10M！');
      }
      return isLt2M;
    },
  },
};
</script>
<style lang="less" scoped>

</style>